import React from 'react';
import {
  AvailableNowTile,
  AvailableNowContainer,
  AvailableNowSubtitle,
  AvailableNowTitle,
  AvailableNowItemWrapper,
  AvailableNowSectionTitle,
} from './styles';
import { useIntl } from 'react-intl';
import { useAppInstanceConfigFeature } from 'hooks/use-app-instance-config-feature.hook';

export const AvailableNowSkeleton = (): JSX.Element => {
  const { isCompactUiEnabled } = useAppInstanceConfigFeature();
  const intl = useIntl();

  return (
    <>
      <AvailableNowSectionTitle>{intl.formatMessage({ id: 'available_now' })}</AvailableNowSectionTitle>
      <AvailableNowContainer gap={19} isWidth flex={1} data-testid="available-now-skeleton">
        <AvailableNowItemWrapper isCompactUiEnabled={isCompactUiEnabled}>
          <AvailableNowTile />
          {!isCompactUiEnabled && (
            <>
              <AvailableNowTitle className="title" data-testid="available-now-skeleton-tile-title-one" />
              <AvailableNowSubtitle className="subtitle" data-testid="available-now-skeleton-tile-subtitle-one" />
            </>
          )}
        </AvailableNowItemWrapper>
        <AvailableNowItemWrapper isCompactUiEnabled={isCompactUiEnabled}>
          <AvailableNowTile />
          {!isCompactUiEnabled && (
            <>
              <AvailableNowTitle className="title" data-testid="available-now-skeleton-tile-title-two" />
              <AvailableNowSubtitle className="subtitle" data-testid="available-now-skeleton-tile-subtitle-two" />
            </>
          )}
        </AvailableNowItemWrapper>
      </AvailableNowContainer>
    </>
  );
};
